import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
const outcomes = [{
  layer: 'Hollywood Intro',
  serves: 'Speaker Vanity + KOL Advocacy',
  impact: 'Immediate credibility and engagement'
}, {
  layer: 'The Menu',
  serves: 'HCP Enablement',
  impact: 'Personalized learning paths'
}, {
  layer: 'Scientific Core',
  serves: 'HCP Enablement + KOL Advocacy',
  impact: 'Unbiased, credible education'
}, {
  layer: 'X-Ray Overlay',
  serves: 'All Three Objectives',
  impact: 'Enhanced value without disruption'
}];
export function Closing() {
  return <section className="py-24 bg-white" data-id="element-9">
      <div className="max-w-6xl mx-auto px-6" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-11">
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-12">
            Why It Works
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-13">
            Each layer serves the strategic objectives — nothing is decorative
          </p>
        </motion.div>

        <div className="space-y-6 mb-16" data-id="element-14">
          {outcomes.map((outcome, index) => <motion.div key={outcome.layer} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-red-300 transition-colors" data-id="element-15">
              <div className="flex items-start gap-4" data-id="element-16">
                <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center flex-shrink-0" data-id="element-17">
                  <CheckCircle2 className="w-6 h-6 text-white" data-id="element-18" />
                </div>
                <div className="flex-1" data-id="element-19">
                  <div className="flex items-center gap-3 mb-2" data-id="element-20">
                    <h3 className="text-xl font-bold text-slate-900" data-id="element-21">
                      {outcome.layer}
                    </h3>
                    <ArrowRight className="w-5 h-5 text-slate-400" data-id="element-22" />
                    <span className="text-sm font-semibold text-red-600" data-id="element-23">
                      {outcome.serves}
                    </span>
                  </div>
                  <p className="text-slate-600" data-id="element-24">{outcome.impact}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-slate-950 to-slate-900 rounded-2xl p-12 text-center" data-id="element-25">
          <h3 className="font-editorial text-3xl font-bold text-white mb-4" data-id="element-26">
            Next Steps
          </h3>
          <p className="text-slate-300 text-lg mb-8 max-w-2xl mx-auto" data-id="element-27">
            Refine speaker selection, finalize topic structure, and begin
            production planning for the 6-video Master-Class series
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4" data-id="element-28">
            <button className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors" data-id="element-29">
              Schedule Production Meeting
            </button>
            <button className="px-8 py-4 bg-slate-800 hover:bg-slate-700 text-white font-semibold rounded-lg transition-colors" data-id="element-30">
              Review Budget & Timeline
            </button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 text-center text-sm text-slate-500" data-id="element-31">
          <p data-id="element-32">
            Prepared for Leo Pharma •{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          </p>
        </motion.div>
      </div>
    </section>;
}